import styled, { css } from 'styled-components';
import { Color } from '../../../app/StyleGuide';

type ChoiceIndicatorProps = {
  $checked?: boolean;
  $color?: string;
  $size?: number;
};

export const ChoiceIndicator = styled.span<ChoiceIndicatorProps>`
  display: inline-flex;
  width: ${props => props.$size ?? 20}px;
  min-width: ${props => props.$size ?? 20}px;
  height: ${props => props.$size ?? 20}px;
  border-radius: 100%;
  flex-shrink: 0;
  transition: all 0.15s ease;
  border: 2px solid ${Color.Gray._30};
  background: ${Color.white};
  box-shadow: none;

  ${props =>
    props.$checked &&
    css`
      border-color: ${props.$color ?? Color.Gray._70};
      background: ${props.$color ?? Color.Gray._70};
      box-shadow: inset 0 0 0 3px ${Color.white};
    `}

  &:hover {
    border-color: ${props => props.$color ?? Color.Gray._70};
  }

  &:focus {
    box-shadow: ${props =>
      props.$checked
        ? `inset 0 0 0 3px ${Color.white}, 0 0 0 3px rgba(172, 211, 239, 0.3)`
        : '0 0 0 3px rgba(172, 211, 239, 0.3)'};
  }
`;
